module.exports = __webpack_public_path__ + "img/SL-M-260-340.ed2fc475.svg";